import { produce } from 'immer';
import { SET_CHECK_RECOVER_LOGIN_RESULT_FROM_INBOUND, SET_IS_RESET_PASSWORD_PENDING, SET_RECOVER_LOGIN_STATUS, SET_RESET_PASSWORD_ERROR } from '../actions/recoverLoginActions';
const initialState = {
    status: 'initial'
};
const recoverLoginReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_RECOVER_LOGIN_STATUS: {
                draft.status = action.payload;
                break;
            }
            case SET_CHECK_RECOVER_LOGIN_RESULT_FROM_INBOUND: {
                const { validPlayer } = action.payload;
                draft.status = validPlayer ? 'valid-uuid' : 'invalid-uuid';
                draft.validPlayer = validPlayer;
                break;
            }
            case SET_IS_RESET_PASSWORD_PENDING: {
                draft.isResetPasswordPending = action.payload;
                break;
            }
            case SET_RESET_PASSWORD_ERROR: {
                draft.error = action.payload;
                delete draft.isResetPasswordPending;
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default recoverLoginReducer;
